import React from 'react';
// import Markdown from 'markdown-to-jsx';
import { MuiMarkdown as Markdown } from 'mui-markdown';
import ComponentContainer from './atoms/ComponentContainer';
import ComponentHeading from './atoms/ComponentHeading';
import type { Text as TextProps } from '../types/app';

export const Text = (props: TextProps) => (
    <ComponentContainer contentful_id={props.contentful_id}>
        <ComponentHeading data-sb-field-path="heading">
            {props.heading}
        </ComponentHeading>
        <Markdown options={{ forceBlock: true }} data-sb-field-path="body">
            {props.body.body}
        </Markdown>
    </ComponentContainer>
);

export default Text;
